import React, { useContext } from "react";
import * as compatManager from '../../compatManager';
import { NavObjectType, NavObjectWinState, TabNames, lddGlobalSessionInfo } from "../navigationTypes";
import { useEffect } from "react";
import { NavigationContext } from "../../Context/NavigationContext";
import { useDispatch } from "react-redux";
import { ReducerEnum, setIndicators, setLenderVerified, setRoot, setShowLenderCentre, setShowUserContactList, setInboxState, setShowLenderCredentialsError, setShowChequePrinting, setEditChequeDetails, setEditChequeIndex, setShowEditFileNumberWarning, setDisplayToastMessage, setPropertyCoordinate } from "../../redux/reducer";
import { PSM } from "../../util/rpwTypes";
import { useAppSelector } from "../../redux/hooks";
import { getDetailsList } from "../../SideDrawer/menus/details";
import { getDataReader } from "../../livedataFuncs";
import KeyDate from "../taskSystem/KeyDate";
import { OpenNewFileDefinition } from "../../Components/fileList/fileList";
import Storage from "../../util/storage";
import { triggerSaveButtonClick } from '../../fileToolbar/fileToolbarMenuItem';

const MainIFrame = (props: { page: NavObjectType }) => {
    const mainIFrameID = "lddIFrame";
    const nav = useContext(NavigationContext);
    const dispatch = useDispatch();
    const SESSION_INFO: lddGlobalSessionInfo = useAppSelector((g) => g.SessionInfo);
    const keyDateTasks = useAppSelector((state) => state.InFileTasks);
    const isCollege = SESSION_INFO?.firm?.IsCollege;

    function goTo(url: string): void {
        const splitIndex = url.indexOf("?");
        let file = url.substring(0, splitIndex);
        if (url.indexOf("compatshell") !== -1) {
            window.location.href = url;
        }
        if (file === 'logout.asp') {
            window.location.href = url;
            return;
        }
        const paramStr = url.substring(splitIndex + 1);
        if (file.indexOf("compathost") !== -1) {
            file = file.substring(file.indexOf("#") + 1);
        }
        let newpage: NavObjectType;
        if (paramStr) {
            const searchParams = new URLSearchParams(paramStr)
            if (file.endsWith("menu.asp")) {
                newpage = { component: 'filelist' }
            } else {
                newpage = { component: 'main', url: file, params: Object.fromEntries(searchParams) }
            }
        } else {
            newpage = { component: 'main', url: file }
        }
        nav(newpage)
    }

    function setDataRootFunc(dataRoot: Element): void {
        if (dataRoot) {
            dispatch(setRoot(dataRoot))
        }
    }

    function ActivityCentreAdd(msg, onclick, type, lddActivityCenterTracker, clearWhenOut?: boolean) {
        const eventParams = {
            detail: {
                event: "add",
                param: {
                    msg: msg,
                    onclick: onclick,
                    type: type === '' ? 'word' : type,
                    lddActivityCenterTracker: lddActivityCenterTracker,
                    clearWhenOut: clearWhenOut
                }
            }
        }
        const event = new CustomEvent("LDDActivityCentre", eventParams);
        dispatchEvent(event);
    }

    function ActivityCentreDel(counter: number) {
        const eventParams = { detail: { event: "delete", param: { counter: counter } } }
        const event = new CustomEvent("LDDActivityCentre", eventParams);
        dispatchEvent(event);
    }

    function openTPAppFromCalendar(TPAppID: string, PSM: PSM, tb: string) {
        if (TPAppID > "") {
            const newpage: NavObjectType = {
                component: 'main',
                url: 'lfmaster.asp',
                params: {
                    'formasp': (PSM === "O") ? "purfilepolaris" : "purfileedit",
                    'tb': tb,
                    'id': TPAppID,
                    'NoHeader': '1',
                    'compat': '1',
                },
            }
            nav(newpage);
        }
    }

    function useNavigateFile(appid: number, PSM: PSM, wantNewWindow = false): void {
        const navigationObj: NavObjectType = OpenNewFileDefinition(PSM, appid);
        if (wantNewWindow) {
            const sid = SESSION_INFO.sid;
            let url = "compatshell.html?SessionID=" + sid + "&params=" + encodeURIComponent(JSON.stringify(navigationObj));
            window.open(url, "_blank");
            return;
        }
        nav(navigationObj);
    }

    function useNavigateToUserSetting(): void {
        const OpenUserSettings: NavObjectType =
        {
            component: "main",
            url: "lfmaster.asp",
            popup: false,
            params: { "formasp": "EditUserCredentials" }
        };
        nav(OpenUserSettings);
    }

    function useNavigateToDocMasters(): void {
        const OpenDocMasters: NavObjectType =
        {
            component: "docmasters",
            reactFrame: "docmasters",
        };
        nav(OpenDocMasters);
    }

    function useNavigateToPackage(): void {
        const OpenPackage: NavObjectType =
        {
            component: "docmasters",
            reactFrame: "packages",
        };
        nav(OpenPackage);
    }

    function navigateToScreen(nodeIndex: number, nodeName: TabNames, listName: string, psm: string, appid: string, label: string, reactFrame?: string,): void {
        let navigateScreenObj: NavObjectType;
        getDetailsList(SESSION_INFO.appProvinceShort, SESSION_INFO.sid, isCollege).then(list => {
            list.forEach((ele) => {
                if (ele.label === listName) {
                    navigateScreenObj = ele.navigate;
                }
            });
            navigateScreenObj.params = {
                formasp: 'purfileedit',
                tb: "TPAppXML",
                "id": appid,
                "PSM": psm,
            }
            navigateScreenObj.controller = {
                tabName: nodeName,
                tabNumber: nodeIndex
            }
            navigateScreenObj.label = label;
            reactFrame > '' ? navigateScreenObj.reactFrame = reactFrame : navigateScreenObj.reactFrame = null;

            nav(navigateScreenObj);
        });
    }

    function updateShellItemView(): void {
        dispatch({
            type: ReducerEnum.SET_SIDEMENURELOAD,
            payload: new Date().getTime()
        })
    }

    function PurfileNewCreateClick(daraRoot: Element): void {
        KeyDate.SaveKeyDates(getDataReader(daraRoot), SESSION_INFO);
    }

    function openDRMsgFromInbox(MsgNode: ajaxslt.XNode): void {
        const msgId = MsgNode.getAttribute("MsgID");
        if (msgId > "" && Number(msgId)) {
            // call notifications
            dispatch(setInboxState(true, msgId));
        }
    }

    function openInboxFromMortgage(): void {
        const navigationObj: NavObjectType = {
            component: "main",
            popup: true,
            isModal: true,
            reactModalFrame: "mortimp",
        };
        nav(navigationObj);
    }

    function MyDriveIndicatorOn(): void {
        dispatch(setIndicators("MyDriveHasNewDoc", true));
    }

    function OpenAnalyzedPDF(appID: string, docName: string): void {
        Storage.viewPDF(docName, 'Analyzer', appID, SESSION_INFO);
    }
    function isLenderVerified(dataRoot: any): boolean {
        const lawyer = dataRoot.selectSingleNode('lawyer');
        const thirdPartyAccounts = lawyer.selectSingleNode('ThirdPartyAcounts');
        let telusUsername = '';
        let telusPassword = '';
        let accNumber = '';
        let assystCookies = '';

        if (thirdPartyAccounts) {
            const accounts = thirdPartyAccounts.selectNodes('Account');
            for (let i = 0; i < accounts.length; i++) {
                telusUsername = accounts[i].getAttribute('TelusUsername') || telusUsername;
                telusPassword = accounts[i].getAttribute('TelusPassword') || telusPassword;
                accNumber = accounts[i].getAttribute('AccountNumber') || accNumber;
                assystCookies = accounts[i].getAttribute('Cookies') || assystCookies;
            }
            
            const hasCredentials = telusUsername && telusPassword && accNumber;
            
            if (hasCredentials) {
                if (assystCookies) {
                    dispatch(setLenderVerified(true));
                    dispatch(setShowLenderCentre(false));
                    dispatch(setShowLenderCredentialsError(false));
                    return true;
                } else {
                    dispatch(setLenderVerified(false));
                    dispatch(setShowLenderCentre(false));
                    dispatch(setShowLenderCredentialsError(true));
                    return false;
                }
            } else {
                dispatch(setLenderVerified(false));
                dispatch(setShowLenderCentre(true));
                dispatch(setShowLenderCredentialsError(false));
                return false;
            }
        } else {
            dispatch(setLenderVerified(false));
            dispatch(setShowLenderCentre(true));
            dispatch(setShowLenderCredentialsError(false));
            return false;
        }
    }
    function ShowUserContactList(): void {
        dispatch(setShowUserContactList(true))
    }

    function OpenLenderList (): void {
        dispatch({type: ReducerEnum.SET_MORTGAGELENDER});
    }

    function OpenLawyerList (): void {
        dispatch({type: ReducerEnum.SET_LAWYERLIST});
    }

    function handleChequePrinting(): void {
        dispatch(setShowChequePrinting(true));
    }

    function handleDisplayToastMessage(message: string, status: string): void {
        dispatch(setDisplayToastMessage(message, status));
    }

    function triggerEditChequeDetails(index: string): void {
        dispatch(setEditChequeIndex(index));
        dispatch(setEditChequeDetails(true));
    }

    function ShowEditFileNumberWarning(): void {
        dispatch(setShowEditFileNumberWarning(true));
    }

    function saveFileViaButton(): void {
        triggerSaveButtonClick();
    }

    function updatePropertyCoordinate(coordinate: string): void {
        dispatch(setPropertyCoordinate(coordinate));
    }

    useEffect(() => {
        compatManager.init(document.getElementById(mainIFrameID), {
            serviceObjs:
            {
                'topWindowLddCentralNavigateAway': goTo,
                'topWindowLddSetDataRoot': setDataRootFunc,
                'topWindowlddActivityCenterAdd': ActivityCentreAdd,
                'topWindowlddActivityCenterDelete': ActivityCentreDel,
                'topWindowOpenTPAppFromCalendar': openTPAppFromCalendar,
                'topWindowNavigateToFile': useNavigateFile,
                'topWindowNavigateToUserSetting': useNavigateToUserSetting,
                'topWindowNavigateToScreen': navigateToScreen,
                'topWindowNavigateToDocMasters': useNavigateToDocMasters,
                'topWindowNavigateToPackage': useNavigateToPackage,
                'topWindowUpdateShellItemView': updateShellItemView,
                'topWindowPurfileNewCreateClick': PurfileNewCreateClick,
                'topWindowOpenDRMsgFromInbox': openDRMsgFromInbox,
                'topWindowMyDriveIndicatorOn': MyDriveIndicatorOn,
                'topWindowOpenAnalyzedPDF': OpenAnalyzedPDF,
                'topWindowIsLenderVerified': isLenderVerified,
                'topWindowShowUserContactList': ShowUserContactList,
                'topWindowOpenLenderList': OpenLenderList,
                'topWindowOpenLawyerList': OpenLawyerList,
                'topWindowOpenInboxFromMortgage': openInboxFromMortgage,
                'topWindowHandleChequePrinting': handleChequePrinting,
                'topWindowTriggerEditChequeDetails': triggerEditChequeDetails,
                'topWindowOpenEditFileNumberWarning': ShowEditFileNumberWarning,
                'topWindowSaveFileWithKeyDates': saveFileViaButton,
                'topWindowHandleDisplayToastMessage': handleDisplayToastMessage,
                'topWindowSetPropertyCoordinate' : updatePropertyCoordinate,
            }
        }, nav);
        nav({ ...props.page, init: true });
    }, [])
    return (
        <div id={mainIFrameID} className="justify-content-center text-center iframeBox" />
    );
}
export default MainIFrame;

export function navigateNewPage(navigation: NavObjectType, sid: string, winObj?: NavObjectWinState,): any {
    //Probably harder to work with URL obj since compathost stores everything in hash 
    //Need to move SessionID check out of here, and remove SessionID completely from string, and set it while loading frames
    let url: string | 1 | -1 = navObjectToURLstring(navigation, sid);
    if (typeof url === "string") {
        if (navigation.popup) {
            return compatManager.navigatePopupPage(url, navigation.popupStyle, navigation.isModal, winObj.dialogArguments);
        } else {
            console.assert(!winObj || !winObj.dialogArguments);
            return compatManager.navigateNewPage(url, winObj);
        }
    } else {
        compatManager.navigateNewPage(url)
    }
}

export function navObjectToURLstring(navigation: NavObjectType, sid: string): any {
    let url: string | 1 | -1 = navigation.url;
    if (typeof url === "string") {
        const params = new URLSearchParams(navigation.params)
        if (params && Array.from(params).length) {
            url = url + (url.indexOf("?") === -1 ? "?" : "&") + params.toString()
        }
        if (url.indexOf("SessionID=") === -1) {
            url = url + (url.indexOf("?") === -1 ? "?" : "&") + "SessionID=" + sid
        }
    }
    return url
}